<script setup>
import moment from "moment";
</script>
<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="flex items-center mb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Dokumen Pra-Presentasi PJP Baru
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="row">
              <div
                class="col-md-6 d-flex justify-content-start"
                style="padding-left: 2rem; padding-top: 0.5rem"
              >
                <img
                  src="../../assets/images/borneo-indobara-icon.png"
                  alt=""
                  style="width: 15%; height: auto"
                />
              </div>
              <div
                class="col-md-6 d-flex justify-content-end"
                style="padding-right: 2rem; padding-top: 0.5rem"
              >
                <p class="fs-5 fw-bold" style="">BIB-HSE-PPO-F-096-05</p>
              </div>
            </div>
            <div class="container p-4">
              <h1 class="text-center mb-3 font-inter font-bold text-3xl">
                DAFTAR RIWAYAT HIDUP CALON PJO
              </h1>
              <p
                class="text-center fs-8 mb-3"
                style="font-family: 'Inter-Regular'"
              >
                Formulir ini untuk memberi informasi mengenai daftar riwayat
                hidup calon PJO
              </p>
              <p class="fs-8 mb-2" style="font-family: 'Inter-Regular'">
                Saya yang bertanda tangan di bawah ini:
              </p>

              <!-- form di sini -->
              <form action="#" @submit.prevent="preventSubmit">
                <!-- <div class="row mb-1">
                        <div class="col-md-12">
                            <p class="text-danger fst-italic fs-8 fw-bold">
                                * Wajib diisi
                            </p>
                        </div>
                    </div> -->
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="nama" class="form-label fs-8 fw-bold"
                      >Nama <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nama"
                      placeholder="Masukkan Nama Anda"
                      v-model="formValues.nama"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.nama != null
                      "
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="tempatLahir" class="form-label fs-8 fw-bold"
                      >Tempat Lahir
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="tempatLahir"
                      placeholder="Masukkan Tempat Lahir Anda"
                      v-model="formValues.tempatLahir"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="tanggalLahir" class="form-label fs-8 fw-bold"
                      >Tanggal Lahir
                      <span class="text-danger fs-6">*</span></label
                    >
                    <datepicker
                      v-model="formValues.tanggalLahir"
                      value=""
                      name="tanggalLahir"
                      placeholder="Masukan Tanggal Lahir Anda"
                      class="form-control fs-9"
                      input-class="fw-bold"
                      format="yyyy-MM-dd"
                      :disabled="statusSio != 0 && statusSio != -3"
                    ></datepicker>
                  </div>
                  <div class="col-md-6">
                    <label for="nik" class="form-label fs-8 fw-bold"
                      >NIK <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="nik"
                      placeholder="Masukkan NIK Anda"
                      v-model="formValues.nik"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="jabatan" class="form-label fs-8 fw-bold"
                      >Jabatan <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Masukkan Jabatan Anda"
                      v-model="formValues.jabatan"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.jabatan != null
                      "
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="perusahaan" class="form-label fs-8 fw-bold"
                      >Perusahaan</label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="perusahaan"
                      placeholder="Masukkan Perusahaan Anda"
                      v-model="formValues.perusahaan"
                      disabled="disabled"
                    />
                  </div>
                </div>
                <div class="row mb-5">
                  <div class="col-md-6">
                    <label for="kantorPusat" class="form-label fs-8 fw-bold"
                      >Alamat Kantor Pusat
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="jabatan"
                      placeholder="Masukkan Alamat Kantor Pusat"
                      v-model="formValues.alamatKantorPusat"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="kantorSite" class="form-label fs-8 fw-bold"
                      >Alamat Kantor Site
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="kantorSite"
                      placeholder="Masukkan Alamat Kantor Site"
                      v-model="formValues.alamatKantorSite"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="">
                    <p
                      class="text-start"
                      style="
                        font-family: 'Inter-Thin';
                        font-size: 0.9rem;
                        letter-spacing: 0.1rem;
                        font-weight: bold;
                      "
                    >
                      RIWAYAT PENDIDIKAN
                    </p>
                    <div class="col-md-12 d-flex justify-content-end">
                      <a
                        class="text-danger fs-8"
                        style="text-decoration: none; cursor: pointer"
                        @click="tambahPendidikan()"
                        :hidden="statusSio != 0 && statusSio != -3"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-circle-plus mr-1"
                          style=""
                        />
                        Tambah Riwayat
                      </a>
                    </div>
                  </div>
                  <!-- loop riwayat pendidikan -->
                  <div
                    class="row mb-2"
                    v-for="(row, index) in formValues.pendidikan"
                    :key="index"
                    :class="{ 'border-top pt-2': index > 0 }"
                  >
                    <div class="col-md-6">
                      <label
                        for="lembagaPendidikan"
                        class="form-label fs-8 fw-bold"
                        >Nama Lembaga Pendidikan<span class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control fs-8"
                        id="lembagaPendidikan"
                        placeholder="Masukkan Nama Lembaga Pendidikan"
                        v-model="row.nama_lembaga"
                        :disabled="statusSio != 0 && statusSio != -3"
                      />
                    </div>
                    <div class="col-md-2">
                      <label
                        for="tahunPendidikan"
                        class="form-label fs-8 fw-bold"
                        >Tahun Mulai<span class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control fs-8"
                        id="tahunPendidikan"
                        placeholder="Masukkan Tahun Mulai"
                        v-model="row.tahun"
                        :disabled="statusSio != 0 && statusSio != -3"
                      />
                    </div>
                    <div class="col-md-2">
                      <label
                        for="tahunPendidikanSelesai"
                        class="form-label fs-8 fw-bold"
                        >Tahun Selesai<span class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control fs-8"
                        id="tahunPendidikanSelesai"
                        placeholder="Masukkan Tahun Selesai"
                        v-model="row.tahun_selesai"
                        :disabled="
                          row.till_now === true ||
                          (statusSio != 0 && statusSio != -3)
                        "
                      />
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckPendidikan"
                          v-model="row.till_now"
                          :disabled="statusSio != 0 && statusSio != -3"
                          @change="handleCheckboxChange(row)"
                        />
                        <label
                          class="form-label fs-8"
                          for="flexCheckPendidikan"
                        >
                          Sampai sekarang
                        </label>
                      </div>
                    </div>
                    <div
                      class="col-md-1 d-flex align-items-center justify-content-center"
                    >
                      <a
                        :class="{
                          'd-none':
                            index == 0 && formValues.pendidikan.length == 1,
                        }"
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="hapusPendidikan(index)"
                        :hidden="statusSio != 0 && statusSio != -3"
                      >
                        <font-awesome-icon icon="fa-solid fa-trash" style="" />
                      </a>
                    </div>
                  </div>
                  <!-- end of loop riwayat pendidikan -->
                </div>
                <div class="row">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    RIWAYAT PEKERJAAN
                  </p>
                  <div class="col-md-12 d-flex justify-content-end">
                    <a
                      class="text-danger fs-8"
                      style="text-decoration: none; cursor: pointer"
                      @click="tambahPekerjaan()"
                      :hidden="statusSio != 0 && statusSio != -3"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-circle-plus mr-1"
                        style=""
                      />
                      Tambah Riwayat
                    </a>
                  </div>
                  <!-- loop riwayat pekerjaan -->
                  <div
                    class="row mb-2"
                    v-for="(row, index) in formValues.pekerjaan"
                    :key="index"
                    :class="{ 'border-top pt-2': index > 0 }"
                  >
                    <div class="col-md-6">
                      <label
                        for="nama_perusahaan"
                        class="form-label fs-8 fw-bold"
                        >Nama Perusahaan</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="nama_perusahaan"
                        placeholder="Masukkan Nama Perusahaan"
                        v-model="row.nama_perusahaan"
                        :disabled="statusSio != 0 && statusSio != -3"
                      />
                    </div>
                    <div class="col-md-2">
                      <label
                        for="tahunPekerjaan"
                        class="form-label fs-8 fw-bold"
                        >Tahun Mulai</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="tahunPekerjaan"
                        placeholder="Masukkan Tahun Mulai"
                        v-model="row.tahun"
                        :disabled="statusSio != 0 && statusSio != -3"
                      />
                    </div>
                    <div class="col-md-2">
                      <label
                        for="tahunPekerjaanSelesai"
                        class="form-label fs-8 fw-bold"
                        >Tahun Selesai</label
                      >
                      <input
                        type="text"
                        class="form-control fs-8"
                        id="tahunPekerjaanSelesai"
                        placeholder="Masukkan Tahun Selesai"
                        v-model="row.tahun_selesai"
                        :disabled="
                          row.till_now === true ||
                          (statusSio != 0 && statusSio != -3)
                        "
                      />
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckPerusahaan"
                          v-model="row.till_now"
                          :disabled="statusSio != 0 && statusSio != -3"
                          @change="handleCheckboxChange(row)"
                        />
                        <label
                          class="form-label fs-8"
                          for="flexCheckPerusahaan"
                        >
                          Sampai sekarang
                        </label>
                      </div>
                    </div>
                    <div
                      class="col-md-1 d-flex align-items-center justify-content-center"
                    >
                      <a
                        :class="{
                          'd-none':
                            index == 0 && formValues.pekerjaan.length == 1,
                        }"
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="hapusPekerjaan(index)"
                        :hidden="statusSio != 0 && statusSio != -3"
                      >
                        <font-awesome-icon icon="fa-solid fa-trash" style="" />
                      </a>
                    </div>
                    <div class="col-md-6 mb-2">
                      <label
                        for="jabatanPerusahaan"
                        class="form-label fs-8 fw-bold"
                        >Jabatan</label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="jabatanPerusahaan"
                        placeholder="Masukkan Jabatan Perusahaan"
                        v-model="row.jabatan"
                        :disabled="statusSio != 0 && statusSio != -3"
                      />
                    </div>
                  </div>
                  <!-- end loop riwayat pekerjaan -->
                </div>
                <div class="row mb-3 mt-2">
                  <p
                    class="mb-1"
                    style="
                      font-family: 'Inter-Thin';
                      font-size: 0.9rem;
                      letter-spacing: 0.1rem;
                      font-weight: bold;
                    "
                  >
                    RIWAYAT PELATIHAN/KOMPETENSI
                  </p>
                  <div class="col-md-12 d-flex justify-content-end">
                    <a
                      class="text-danger fs-8"
                      style="text-decoration: none; cursor: pointer"
                      @click="tambahKompetensi()"
                      :hidden="statusSio != 0 && statusSio != -3"
                    >
                      <font-awesome-icon
                        icon="fa-solid fa-circle-plus mr-1"
                        style=""
                      />
                      Tambah Riwayat
                    </a>
                  </div>
                  <div
                    class="row mb-2"
                    v-for="(row, index) in formValues.kompetensi"
                    :key="index"
                    :class="{ 'border-top pt-2': index > 0 }"
                  >
                    <div class="col-md-6">
                      <label for="pelatihan" class="form-label fs-8 fw-bold"
                        >Pelatihan<span class="text-danger fs-6">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="pelatihan"
                        placeholder="Masukkan Pelatihan/Kompetensi"
                        v-model="row.nama_pelatihan"
                        :disabled="statusSio != 0 && statusSio != -3"
                      />
                    </div>
                    <div class="col-md-2">
                      <label
                        for="tahunPelatihan"
                        class="form-label fs-8 fw-bold"
                        >Tahun<span class="text-danger fs-6">*</span></label
                      >
                      <input
                        type="text"
                        class="form-control fs-9"
                        id="tahunPelatihan"
                        placeholder="Masukkan Tahun"
                        v-model="row.tahun"
                        :disabled="statusSio != 0 && statusSio != -3"
                      />
                    </div>
                    <div class="col-md-2">
                      <label
                        for="tahunPelatihanSelesai"
                        class="form-label fs-8 fw-bold"
                        >Tahun Selesai<span class="text-danger fs-6"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        class="form-control fs-8"
                        id="tahunPelatihanSelesai"
                        placeholder="Masukkan Tahun Selesai"
                        v-model="row.tahun_selesai"
                        :disabled="
                          row.till_now === true ||
                          (statusSio != 0 && statusSio != -3)
                        "
                      />
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="flexCheckPelatihan"
                          v-model="row.till_now"
                          :disabled="statusSio != 0 && statusSio != -3"
                          @change="handleCheckboxChange(row)"
                        />
                        <label class="form-label fs-8" for="flexCheckPelatihan">
                          Sampai sekarang
                        </label>
                      </div>
                    </div>
                    <div
                      class="col-md-1 d-flex align-items-center justify-content-center"
                    >
                      <a
                        :class="{
                          'd-none':
                            index == 0 && formValues.kompetensi.length == 1,
                        }"
                        style="
                          font-family: 'Inter-Bold';
                          font-size: 1.2rem;
                          color: #dd3737;
                          cursor: pointer;
                        "
                        @click="hapusKompetensi(index)"
                        :hidden="statusSio != 0 && statusSio != -3"
                      >
                        <font-awesome-icon icon="fa-solid fa-trash" style="" />
                      </a>
                    </div>
                  </div>
                  <div
                    v-if="fileSertifikat != '' && fileSertifikat != null"
                    class="fs-8 row mb-2"
                  >
                    <div class="col-md-6">
                      <b>Nomor Sertifikat PJO : {{ nomorSertifikatPjo }}</b>
                    </div>
                    <div class="col-md-6">
                      <b>File Sertifikat Pelatihan/Kompetensi :</b>
                      <ul>
                        <li v-for="(asse, idx) in fileSertifikat" :key="idx">
                          <a
                            class="text-danger pointer"
                            @click="viewFile(asse.filename)"
                            >{{ asse.actual_name }}</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <p class="mb-3 fs-8" style="font-family: 'Inter-Regular'">
                  Demikian daftar riwayat hidup ini saya buat untuk digunakan
                  sebagaimana mestinya.
                </p>

                <div class="row mb-5">
                  <div class="col-md-3">
                    <label for="tempat" class="form-label fs-8 fw-bold"
                      >Tempat <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="tempat"
                      placeholder="Masukkan Tempat"
                      v-model="formValues.tempat"
                      :disabled="statusSio != 0 && statusSio != -3"
                    />
                  </div>
                  <div class="col-md-3">
                    <label for="tanggal" class="form-label fs-8 fw-bold"
                      >Tanggal <span class="text-danger fs-6">*</span></label
                    >
                    <datepicker
                      v-model="formValues.tanggal"
                      value=""
                      name="tanggal"
                      placeholder="Pilih Tanggal"
                      class="form-control fs-9"
                      input-class="fw-bold"
                      format="yyyy-MM-dd"
                      :disabled="statusSio != 0 && statusSio != -3"
                    ></datepicker>
                  </div>
                </div>
                <div>
                  <p class="fs-8">Dimohon oleh,</p>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <label for="tandaTangan" class="form-label fs-8 fw-bold">
                      Tanda Tangan (png, jpg, jpeg)
                      <span class="text-danger fs-6">*</span>
                    </label>
                    <div v-if="fileTtd != ''" class="fs-8 mb-2">
                      <img :src="fileTtd" style="height: 5rem" />
                    </div>
                    <!-- <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'100%'" :h="'85%'"
                                                    :disabled="state.disabled" class="example border"></Vue3Signature> -->
                    <div
                      class="input-group mb-1"
                      :hidden="
                        (statusSio != 0 && statusSio != -3) || fileTtd != ''
                      "
                    >
                      <input
                        type="file"
                        ref="tandaTangan"
                        accept="image/png, image/jpg, image/jpeg"
                        class="form-control fs-9"
                        id="inputGroupFile04"
                        @change="handleChangeFile('tandaTangan')"
                        aria-describedby="inputGroupFileAddon04"
                        aria-label="Upload"
                      />
                      <button
                        class="btn btn-outline-secondary fs-9 border border-start-0"
                        type="button"
                        id="inputGroupFileAddon04"
                      >
                        <font-awesome-icon
                          icon="fa-solid fa-cloud-arrow-up"
                          style="color: #000000"
                        />
                      </button>
                    </div>
                    <div
                      v-if="validasiFile.size"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ukuran file melebihi batas (Max:
                      {{ max_file_size }}MB)
                    </div>
                    <div
                      v-if="validasiFile.type"
                      class="fs-8 text-danger fst-italic"
                    >
                      Ekstensi file tidak sesuai, Mohon tambahkan file Gambar
                      png, jpg, jpeg
                    </div>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-6">
                    <label for="namaPimpinan" class="form-label fs-8 fw-bold"
                      >Nama Lengkap Calon PJO
                      <span class="text-danger fs-6">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control fs-9"
                      id="namaPimpinan"
                      placeholder="Masukkan Nama Lengkap"
                      v-model="formValues.namaTTD"
                      :disabled="
                        (statusSio != 0 && statusSio != -3) ||
                        formValues.namaTTD != null
                      "
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <p class="text-danger fst-italic fs-8 fw-bold">
                      * Wajib diisi
                    </p>
                  </div>
                  <div class="col-md-6 d-flex justify-content-end">
                    <button
                      type="button"
                      @click="clickSimpan()"
                      class="btn btn_cari w-50"
                      :hidden="statusSio != 0 && statusSio != -3"
                      :disabled="disabled"
                    >
                      {{
                        statusSio == 0
                          ? "Submit"
                          : statusSio == -3
                          ? "Submit Ulang"
                          : "Submit"
                      }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>
<style>
section .vuejs3-datepicker__calendar-topbar {
  min-height: auto;
}

.vuejs3-datepicker__value {
  font-size: 0.7rem !important;
  border: 0px !important;
  padding: 0px !important;
}
.vuejs3-datepicker__icon svg {
  height: 0.8rem;
}

.vuejs3-datepicker__content {
  font-size: 0.8rem !important;
  margin-left: 0.3rem !important;
  margin-bottom: -1rem !important;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent white overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Make sure it's above other elements on the page */
}

.loading-spinner {
  /* Add your loading spinner styles here */
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  /* animation: spin 1s linear infinite; */
}

/* @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
} */
</style>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import GlobalDataMixin from "../../GlobalDataMixin";
import Datepicker from "vuejs3-datepicker";

import axios from "axios";
import Swal from "sweetalert2";

import {
  API_BASE_URL,
  // CMS_UPLOAD,
  CMS_DOWNLOAD,
  CMS_UPLOAD_USECASE,
  CMS_SIO_GET_DASHBOARD,
  CMS_SIO_SET_PJODET,
  CMS_SIO_GET_PJODET,
  CMS_GET_KELENGKAPAN_SIO,
  CMS_VIEW_IMAGE,
  CMS_GET_SIOID,
  CMS_VIEW_DOCUMENT,
} from "../../constants.js";

// const host = API_BASE_URL;
//const host = 'http://localhost:8080/';
const url_simpan = API_BASE_URL + CMS_SIO_SET_PJODET;
const url_get_pjodetail = API_BASE_URL + CMS_SIO_GET_PJODET;

const url_upload_usecase = API_BASE_URL + CMS_UPLOAD_USECASE;
const url_get_siodashboard = API_BASE_URL + CMS_SIO_GET_DASHBOARD;
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_view_document = API_BASE_URL + CMS_VIEW_DOCUMENT;

const url_get_kelengkapan = API_BASE_URL + CMS_GET_KELENGKAPAN_SIO;

const url_download = API_BASE_URL + CMS_DOWNLOAD;
const max_file_size = 5; // MB

import { reactive, ref } from "vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(255,255,255)",
  },
  disabled: false,
});

const signature1 = ref(null);

export default {
  mixins: [GlobalDataMixin],
  name: "FormSuratPermohonanPengesahanPJO",
  components: { DefaultLayout, Datepicker },
  data() {
    return {
      sioID: null,
      idKelengkapan: null,
      isLoading: false,
      refIDForm: 2,
      idForm: null,
      fileSertifikat: null,
      nomorSertifikatPjo: null,
      formValues: {
        nama: "",
        tempatLahir: "",
        tanggalLahir: "",
        nik: "",
        jabatan: "",
        perusahaan: "",
        alamatKantorPusat: "",
        alamatKantorSite: "",
        tempat: "",
        tanggal: moment(new Date()).format("YYYY-MM-DD"),
        tandaTangan: "",
        pendidikan: [
          {
            nama_lembaga: "",
            tahun: null,
            tahun_selesai: null,
            till_now: false,
          },
        ],
        pekerjaan: [
          {
            nama_perusahaan: "",
            tahun: null,
            tahun_selesai: null,
            nama_jabatan: "",
            till_now: false,
          },
        ],
        kompetensi: [
          {
            nama_pelatihan: "",
            tahun: null,
            tahun_selesai: null,
            till_now: false,
          },
        ],
        ttd: "",
        namaTTD: "",
      },
      fileTtd: "",
      url_icon: "",
      validasiFile: {
        type: false,
        size: false,
      },
      statusSio: 0,
      kontraktorID: null,
      disabled: false
    };
  },
  mounted() {
    this.kontraktorID = parseInt(this.userData.kontraktorID);
    if (localStorage.getItem("sio_cms") != null) {
      this.sioID = JSON.parse(localStorage.getItem("sio_cms")).id;
      this.getSioDashboard(this.sioID);
      this.getSioID(this.kontraktorID);
      this.getKelengkapan(this.sioID);
    }

    if (localStorage.getItem("icon_kontraktor_cms") != null) {
      this.url_icon =
        API_BASE_URL +
        CMS_VIEW_IMAGE +
        JSON.parse(localStorage.getItem("icon_kontraktor_cms")).icon;
    }

    this.formValues.perusahaan =
      this.userData.kontraktorName != null
        ? this.userData.kontraktorName
        : null;
  },
  methods: {
    preventSubmit() {
      console.log("prevent submit");
    },
    getSioDashboard(sio_id) {
      axios
        .get(url_get_siodashboard + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_dash = response.data.data;
          if (ret_dash.length > 0) {
            for (let i = 0; i < ret_dash.length; i++) {
              // this.onChangeArr(this.listDokumen,'statusFile',ret_dash[i].formStatus, ret_dash[i].id);
              if (ret_dash[i].idForm == this.refIDForm) {
                this.idForm = ret_dash[i].id;
                this.getPJODetail(ret_dash[i].id);
              }
            }
          }
          // this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getPJODetail(idform) {
      axios
        .get(url_get_pjodetail + idform, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("getPJODetail", response);
          let dt = response.data.data;

          if (dt != null) {
            // this.formValues.nama = dt.nama==null?'':dt.nama;
            this.formValues.tempatLahir =
              dt.tempatLahir == null ? "" : dt.tempatLahir;
            // this.formValues.jabatan = dt.jabatan==null?'':dt.jabatan;
            this.formValues.tanggalLahir =
              dt.tanggalLahir != null
                ? moment(dt.tanggalLahir).format("YYYY-MM-DD")
                : null;
            this.formValues.nik = dt.nik == null ? "" : dt.nik;
            this.formValues.alamatKantorPusat =
              dt.alamatKantorPusat == null ? "" : dt.alamatKantorPusat;
            this.formValues.alamatKantorSite =
              dt.alamatKantorSite == null ? "" : dt.alamatKantorSite;
            this.formValues.kompetensi = JSON.parse(dt.riwayatPelatihan);
            this.formValues.pendidikan = JSON.parse(dt.riwayatPendidikan);
            this.formValues.pekerjaan = JSON.parse(dt.riwayatPekerjaan);
            this.formValues.tempat = dt.tempat == null ? "" : dt.tempat;
            this.formValues.tanggal =
              dt.tanggalTtd != null
                ? moment(dt.tanggalTtd).format("YYYY-MM-DD")
                : null;
            // if(dt.tandaTangan!=''&&dt.tandaTangan!=null){
            //     this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + dt.tandaTangan;
            // }
            // this.formValues.namaTTD = dt.namaPengesah==null?'':dt.namaPengesah;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioDashboard : " + error.message);
          console.error("Error fetching data getSioDashboard :", error.message);
        });
    },
    getKelengkapan(sio_id) {
      axios
        .get(url_get_kelengkapan + sio_id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log(response);
          // this.kontraktor = response.data.detailKontraktor
          // // set value form edit
          // this.formValues.namaKontraktor = this.kontraktor.namaKontraktor
          let ret_kel = response.data;
          this.idKelengkapan = ret_kel.id == null ? "" : ret_kel.id;
          this.formValues.nama = ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          this.formValues.jabatan =
            ret_kel.jabatanPjo == null ? "" : ret_kel.jabatanPjo;
          this.formValues.namaTTD =
            ret_kel.namaPjo == null ? "" : ret_kel.namaPjo;
          // this.formValues.jabatanAtasan = ret_kel.jabatanAtasan;
          // this.formValues.fileTtdPjo = ret_kel.ttdPjo;
          this.fileSertifikat =
            ret_kel.assets != null && ret_kel.assets != ""
              ? JSON.parse(ret_kel.assets)
              : null;
          if (ret_kel.ttdPjo != "" && ret_kel.ttdPjo != null) {
            this.fileTtd = API_BASE_URL + CMS_VIEW_IMAGE + ret_kel.ttdPjo;
          }
          this.nomorSertifikatPjo = ret_kel.nomorSertifikatPjo;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getKelengkapan : " + error.message);
          console.error("Error fetching data getKelengkapan :", error.message);
        });
    },
    tambahPendidikan() {
      this.formValues.pendidikan.push({
        nama_lembaga: "",
        tahun: null,
        tahun_selesai: null,
        till_now: false,
      });
    },
    hapusPendidikan(index) {
      this.formValues.pendidikan.splice(index, 1);
    },
    tambahPekerjaan() {
      this.formValues.pekerjaan.push({
        nama_perusahaan: "",
        tahun: null,
        tahun_selesai: null,
        nama_jabatan: "",
        till_now: false,
      });
    },
    hapusPekerjaan(index) {
      this.formValues.pekerjaan.splice(index, 1);
    },
    tambahKompetensi() {
      this.formValues.kompetensi.push({
        nama_pelatihan: "",
        tahun: null,
        tahun_selesai: null,
        till_now: false,
      });
    },
    hapusKompetensi(index) {
      this.formValues.kompetensi.splice(index, 1);
    },
    async simpanForm() {
      this.disabled = true
      const tandaTangan = this.$refs.tandaTangan.files[0];
      this.formValues.ttd = tandaTangan;
      let bodyJsonProfile = {};
      if (this.idForm != null) {
        bodyJsonProfile = {
          id: this.idForm,
          idSio: this.sioID,
          kontraktorId: this.userData.kontraktorID,
          nama: this.formValues.nama,
          tempatLahir: this.formValues.tempatLahir,
          tanggalLahir:
            this.formValues.tanggalLahir != null &&
            this.formValues.tanggalLahir != ""
              ? moment(this.formValues.tanggalLahir).format("YYYY-MM-DD")
              : null,
          nik: this.formValues.nik,
          jabatan: this.formValues.jabatan,
          // "perusahaan":this.formValues.perusahaan,
          alamatKantorPusat: this.formValues.alamatKantorPusat,
          alamatKantorSite: this.formValues.alamatKantorSite,
          riwayatPendidikan: JSON.stringify(this.formValues.pendidikan),
          riwayatPekerjaan: JSON.stringify(this.formValues.pekerjaan),
          riwayatPelatihan: JSON.stringify(this.formValues.kompetensi),
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tempat: this.formValues.tempat,
          reason: "",
          // "tandaTangan": "string",
          // "namaPengesah": this.formValues.namaTTD,
        };
      } else {
        bodyJsonProfile = {
          // "id": this.idForm,
          idSio: this.sioID,
          kontraktorId: this.userData.kontraktorID,
          nama: this.formValues.nama,
          tempatLahir: this.formValues.tempatLahir,
          tanggalLahir:
            this.formValues.tanggalLahir != null &&
            this.formValues.tanggalLahir != ""
              ? moment(this.formValues.tanggalLahir).format("YYYY-MM-DD")
              : null,
          nik: this.formValues.nik,
          jabatan: this.formValues.jabatan,
          // "perusahaan":this.formValues.perusahaan,
          alamatKantorPusat: this.formValues.alamatKantorPusat,
          alamatKantorSite: this.formValues.alamatKantorSite,
          riwayatPendidikan: JSON.stringify(this.formValues.pendidikan),
          riwayatPekerjaan: JSON.stringify(this.formValues.pekerjaan),
          riwayatPelatihan: JSON.stringify(this.formValues.kompetensi),
          tanggalTtd:
            this.formValues.tanggal != null && this.formValues.tanggal != ""
              ? moment(this.formValues.tanggal).format("YYYY-MM-DD")
              : null,
          tempat: this.formValues.tempat,
          // "tandaTangan": "string",
          namaPengesah: this.formValues.namaTTD,
          reason: "",
        };
      }

      await axios
        .post(url_simpan, bodyJsonProfile, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          console.log("response simpanForm : ", response);
          // console.log("data : ", response.data)
          // console.log(tandaTangan!=null);
          let idform = response.data.id;
          // alert(idkontrak);
          if (this.formValues.ttd != null) {
            this.uploadFile(tandaTangan, idform);
          } else {
            this.alertSukses();
          }
        })
        .catch((error) => {
          console.log("error simpanForm : ", error);
          alert("error simpanForm");
          // if(error.response.status==500){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==400){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }else if(error.response.status==401){
          //     alert("Error "+error.response.status+" simpanAddSubKontraktor : " + error.response.data.status.message)
          // }
        })
        .then(() => {});
    },

    async uploadFile(file, idform) {
      if (file) {
        // Get the file name
        const fileName = file.name;

        // Create a FormData object and append the file
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", idform);
        formData.append("purpose", "form2");
        formData.append("usecase", "ttd_form2");

        // Make the API request to upload the file
        try {
          const response = await axios.post(url_upload_usecase, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              role: this.userData.role,
              Authorization: "Bearer " + this.userData.token,
              accept: "*/*",
            },
          });

          // Handle the response from the server as needed
          console.log("File upload response:", response.data);
          console.log("filename : ", fileName);

          this.alertSukses();
        } catch (error) {
          // Handle errors, e.g., display an error message to the user
          alert(error.message);
          if (error.response.data != null) {
            alert(error.response.data.message);
          }
          this.isLoading = false;
          console.error("Error uploading file:", error);
          // this.$router.go(this.$router.currentRoute)
        }
      }
    },
    clickSimpan() {
      this.isLoading = true;
      if (this.validasiForm()) {
        this.simpanForm();
      } else {
        alert("Lengkapi pengisian form !");
        this.isLoading = false;
      }
    },
    validasiForm() {
      if (
        this.formValues.nama != "" &&
        this.formValues.tempatLahir.trim() != "" &&
        this.formValues.tanggalLahir != "" &&
        this.formValues.nik.trim() != "" &&
        this.formValues.jabatan != "" &&
        this.formValues.alamatKantorPusat.trim() != "" &&
        this.formValues.alamatKantorSite.trim() != "" &&
        this.formValues.tempat.trim() != "" &&
        this.formValues.tanggal != "" &&
        this.formValues.namaTTD != "" &&
        (this.fileTtd != "" || this.$refs.tandaTangan.value != "") &&
        this.formValues.pendidikan.length > 0 &&
        this.formValues.pendidikan?.every((pendidikan) => {
          return (
            pendidikan.nama_lembaga?.trim() !== "" &&
            pendidikan.tahun?.trim() !== "" &&
            ((pendidikan.tahun_selesai?.trim() !== undefined &&
              pendidikan.tahun_selesai?.trim() !== "") ||
              pendidikan.till_now)
          );
        }) &&
        this.formValues.kompetensi.length > 0 &&
        this.formValues.kompetensi.every((kompetensi) => {
          return (
            kompetensi.nama_pelatihan?.trim() !== "" &&
            kompetensi.tahun?.trim() !== "" &&
            ((kompetensi.tahun_selesai?.trim() !== undefined &&
              kompetensi.tahun_selesai?.trim() !== "") ||
              kompetensi.till_now)
          );
        })
      ) {
        return true;
      } else {
        return false;
      }
    },

    save(t) {
      console.log(signature1.value.save(t));
      console.log(signature1);
      console.log(signature1.value);
      state.disabled = true;
    },

    clear() {
      signature1.value.clear();
      state.disabled = false;
    },

    undo() {
      signature1.value.undo();
      state.disabled = false;
    },

    alertSukses() {
      Swal.fire({
        title: "Simpan Form Sukses",
        text: "Daftar Riwayat Hidup Calon PJO berhasil disimpan !",
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        this.$router.back();
      });
    },
    handleChangeFile(refFile) {
      let file = null;
      if (refFile == "tandaTangan") {
        file = this.$refs.tandaTangan.files[0];
      }
      // console.log('Valid file:', file);
      if (file) {
        // Check file type
        if (
          file.type !== "image/jpg" &&
          file.type !== "image/jpeg" &&
          file.type !== "image/png"
        ) {
          this.validasiFile.type = true;
          this.validasiFile.size = false;
          this.$refs.tandaTangan.value = "";
          return;
        }

        // Check file size ({{max_file_size}}MB limit)
        if (file.size > max_file_size * 1024 * 1024) {
          this.validasiFile.type = false;
          this.validasiFile.size = true;
          this.$refs.tandaTangan.value = "";
          return;
        }

        // Reset error messages if the file is valid
        this.validasiFile.type = false;
        this.validasiFile.size = false;

        // Handle the valid file as needed (e.g., store the file)
        console.log("Valid file:", file);
      }
    },

    downloadFile(filename) {
      axios
        .get(url_download + filename, { responseType: "blob" })
        .then((response) => {
          this.handleFileDownload(response.data, filename);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    },
    handleFileDownload(blobData, filename) {
      // Create a Blob from the response data
      const blob = new Blob([blobData], { type: "application/octet-stream" });
      console.log("blob nya = ", blob);
      // Create a link element and trigger a download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename; // Set the desired file name
      link.click();
    },
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.userData.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        })
        .then((response) => {
          this.statusSio = response.data.data.status;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    handleCheckboxChange(row) {
      if (row.till_now) {
        // row.tahun = null;
        row.tahun_selesai = null;
      }
    },
    viewFile(fileName) {
      window.open(url_view_document + fileName, "_blank");
    },
  },
};
</script>
